import { put, call, all, spawn, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../constants/onboarding';
import * as actions from '../actions/onboarding';
import { onboardingServices } from 'Redux/services/onboarding';
import parseDjangoError from 'Utils/parseDjangoError';

// create organization
function* apiCreateOrganizationWorker(action) {
  try {
    const result = yield call(onboardingServices.apiCreateOrganization, action);
    toast.success('Organization Created Successfully!');
    yield put(actions.createOrganizationSuccess(result, action));
  } catch (err) {
    toast.error(parseDjangoError(err?.response?.data));
    yield put(actions.createOrganizationFailed(err, action));
  }
}

function* apiCreateOrganizationWatcher() {
  yield takeEvery(types.API_CREATE_ORG, apiCreateOrganizationWorker);
}

// Read more information about root sagas in the documentation
// https://redux-saga.js.org/docs/advanced/RootSaga.html
export default function* onboardingRootSaga() {
  const sagas = [apiCreateOrganizationWatcher];

  yield all(
    sagas.map(saga =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
        }
      }),
    ),
  );
}
